<template>
  <div
    v-if="bundles.length > 0"
    class="product-attachment-options"
  >
    <legend
      v-if="$string('product.sidebar.bundle_attachments') && bundles.length > 0"
      class="product-attachment-options__title text-body-l-bold"
      v-text="$string('product.sidebar.bundle_attachments')"
    />
    <p  v-if="$string('product.sidebar.bundle_description')" class="mt-s rte text-body-l-regular" v-text="$string('product.sidebar.bundle_description')"/>
    <div
      v-for="(bundle, index) of bundles"
      :key="index"
      class="product-attachment-options__option"
      :class="{
        [$class('active')]: isSelectedAttachment(bundle),
        [$class('disabled')]: !bundle.available,
      }"
      :data-id="bundle.id"
    >
      <div v-for="(tag , tagindex) of bundle.tags"  :key="tagindex"  >
         <div  class="product-attachment-options__tags" v-if="tag == 'gift:free'"><span  v-if="giftui.length > 0" class="text-body-l-bold" v-text="giftui[0].attachmentlabel"></span></div> 
      </div>
      <div class="product-attachment-options__input-wrapper">
        <div
          class="product-attachment-options__header"
        >
        <img  v-if="bundle.featuredImage.src" :src="bundle.featuredImage.src" class="product-attachment-options__image" loading="lazy"  :alt="bundle.featuredImage.alt" >
        <img  v-else :src="noimage" class="product-attachment-options__image" :alt="bundle.featuredImage.alt" loading="lazy" >
        
       <div class="product-attachment-options__details-box">
        <h3 class=" text-heading-mobile text-heading-m-desktop">{{ bundle.title }} </h3>
        <product-prices
            class-price="text-heading-2xs"
            class-compare-at-price="text-heading-2xs"
            :price="getPrice(bundle)"
            :compare-at-price="getPrice(bundle, 'compare')"
            :currency-symbol-small="false"
            :affirm="false"
            element="span"
            prefix="+"
        />
       
       </div>
      
        </div>

        <div
          v-if="hasMultiVariants(bundle)"
          class="product-attachment-options__variants form-group"
        >
          <select
            :id="`${bundle.handle}-variants`"
            v-model="selectedVariantModelValues[bundle.handle]"
            :name="bundle.handle"
          >
            <option
              v-for="(variant) of bundle.variants"
              :key="variant.id"
              :value="variant.id"
              :disabled="!variant.available"
              v-text="variant.title"
            />
          </select>
        </div>
        <div class="product-attachment-options__check-box">
          <checkbox-input-pdp
            :id="`attachment-${bundle.id}`"
            :checked="isSelectedAttachment(bundle)"
            :disabled="!bundle.available"
            :value="bundle.id"
            @update:model-value="bundle.available
              ? handleAttachmentSelection(bundle) : {}
            "
          />
           
        </div>
      </div>

      <div
        class="product-attachment-options__content"
      >
        <div class="product-attachment-options__content-header">
          <p
            class="product-attachment-options__toggle"
            @click="toggleAccordion(bundle.id)"
          >
            <span
              v-if="activeAccordion !== bundle.id"
            >
           + &nbsp;{{ $string('product.sidebar.view_details') }}
          </span>
            <span v-else>- &nbsp;{{$string('product.sidebar.hide_details') }}</span>
          </p>

          
        </div>

        <div
          class="product-attachment-options__copy"
        >
          <transition-height>
            <div
              v-show="activeAccordion === bundle.id"
              class="rte"
            >
              <div class="">
                <p
                  class="product-attachment-options__description"
                  v-text="bundle.description"
                />
                <div
                  v-if="bundle.included"
                  class="product-attachment-options__included mt-m"
                >
                  <p v-text="$string('product.sidebar.includes')" />
                  <div v-html="bundle.included" />
                </div>
                <div class="product-attachment-options__footer mt-xs">
                  <a
                    class="text-link"
                    :href="bundle.url"
                    v-text="$string('product.sidebar.view_more_details')"
                  />
                </div>
              </div>
            </div>
          </transition-height>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="attachments.length > 0"
    class="product-attachment-options mt-s"
  >
    <legend
      v-if="$string('product.sidebar.optional_attachments') && attachments.length > 0"
      class="product-attachment-options__title text-body-l-bold"
      v-text="$string('product.sidebar.optional_attachments')"
    />
    <div
      v-for="(attachment, index) of attachments"
      :key="index"
      class="product-attachment-options__option"
      :class="{
        [$class('active')]: isSelectedAttachment(attachment),
        [$class('disabled')]: !attachment.available,
      }"
      :data-id="attachment.id"
    >
      <div v-for="(tag , tagindex) of attachment.tags"  :key="tagindex"  >
         <div  class="product-attachment-options__tags" v-if="tag == 'gift:free'"><span  v-if="giftui.length > 0" class="text-body-l-bold" v-text="giftui[0].attachmentlabel"></span></div> 
      </div>
      <div class="product-attachment-options__input-wrapper">
        <div
          class="product-attachment-options__header"
        >
        <img  v-if="attachment.featuredImage.src" :src="attachment.featuredImage.src" class="product-attachment-options__image" loading="lazy" :alt="attachment.featuredImage.alt" >
        <img v-else :src="noimage" class="product-attachment-options__image" :alt="attachment.featuredImage.alt" loading="lazy"  >
       <div class="product-attachment-options__details-box">
        <h3 class=" text-heading-mobile text-heading-m-desktop">{{ attachment.title }} </h3>
        <div
          v-if="hasMultiVariants(attachment)"
          class="product-attachment-options__variants form-group"
        >
          <select
            :id="`${attachment.handle}-variants`"
            v-model="selectedVariantModelValues[attachment.handle]"
            :name="attachment.handle"
          >
            <option
              v-for="(variant) of attachment.variants"
              :key="variant.id"
              :value="variant.id"
              :disabled="!variant.available"
              v-text="variant.title"
            />
          </select>
        </div>
       
        <product-prices
            class-price="text-heading-2xs"
            class-compare-at-price="text-heading-2xs"
            :price="getPrice(attachment)"
            :compare-at-price="getPrice(attachment, 'compare')"
            :currency-symbol-small="false"
            :affirm="false"
            element="span"
            prefix="+"
        />
       </div>
        
        </div>

        
          <div class="product-attachment-options__check-box">
            <checkbox-input-pdp
              :id="`attachment-${attachment.id}`"
              :checked="isSelectedAttachment(attachment)"
              :disabled="!attachment.available"
              :value="attachment.id"
              @update:model-value="attachment.available
                ? handleAttachmentSelection(attachment) : {}
              "
            />
            
          </div>
      </div>

      <div
        class="product-attachment-options__content"
      >
        <div class="product-attachment-options__content-header">
          <p
            class="product-attachment-options__toggle"
            @click="toggleAccordion(attachment.id)"
          >
            <span
              v-if="activeAccordion !== attachment.id"
            >
           + &nbsp;{{ $string('product.sidebar.view_details') }}
          </span>
            <span v-else>- &nbsp;{{$string('product.sidebar.hide_details') }}</span>
          </p>

          
        </div>

        <div
          class="product-attachment-options__copy"
        >
          <transition-height>
            <div
              v-show="activeAccordion === attachment.id"
              class="rte"
            >
              <div class="">
                <p
                  class="product-attachment-options__description"
                  v-text="attachment.description"
                />
                <div
                  v-if="attachment.included"
                  class="product-attachment-options__included mt-m"
                >
                  <p v-text="$string('product.sidebar.includes')" />
                  <div v-html="attachment.included" />
                </div>
                <div class="product-attachment-options__footer mt-xs">
                  <a
                    class="text-link"
                    :href="attachment.url"
                    v-text="$string('product.sidebar.view_more_details')"
                  />
                </div>
              </div>
            </div>
          </transition-height>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionHeight from '~async/transition-height/transition-height'
import ProductPrices from '~global/product-prices/product-prices'
import CheckboxInput from '~async/utils/checkbox-input/checkbox-input'
import CheckboxInputPdp from '~async/utils/checkbox-input-pdp/checkbox-input-pdp'
import { emitUpdateVariant } from '~/helpers/vue'

import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductAttachmentOptions',

  components: {
    TransitionHeight,
    ProductPrices,
    CheckboxInput,
    CheckboxInputPdp,
    ResponsiveImage,
  },

  props: {
    attachments: {
      type: [Boolean, Array],
      default: false,
    },
    bundles: {
      type: [Boolean, Array],
      default: false,
    },
    giftui: {
      type: [Array],
      default: () => {
        return []
      },
    },
  },

  emits: {
    'update-selected-attachments': emitUpdateVariant,
  },

  data() {
    return {
      selectedAttachments: [],
      selectedVariantModelValues: {},
      activeAccordion: null,
      noimage : cnvs.urls.assets.replace('placeholder', `no-image.jpg`),
    }
  },

  watch: {

    /**
     * Watch for variant selection changes
     */
    selectedVariantModelValues: {
      handler() {
        this.handleVariantSelection()
      },
      deep: true,
    },
  },

  mounted() {
    // not empty
    this.initSelectedVariantModelValues()
    //console.log('gift', this.giftui)
  },

  methods: {

    /**
     * Get attachment variant price
     * @param {Object} attachment - Attachment object.
     * @param {Boolean} modifier - Modifier for the price.
     */
    getPrice(attachment, modifier) {
      let variant = attachment

      if (this.hasMultiVariants(attachment)) {
        const selectedVariant = attachment.variants.find((item) => {
          return item.id === this.selectedVariantModelValues[attachment.handle]
        })

        if (selectedVariant) {
          variant = selectedVariant
        } else {
          variant = variant.variants[0]
        }
      }

      if (modifier === 'compare') {
        return variant.compareAtPrice.amount
      }

      return variant.price.amount
    },
    
    /**
     * Check if attachment has multiple variants.
     * @param {Object} attachment - Attachment object.
     */
    hasMultiVariants(attachment) {
      return attachment.variants.length > 1
    },

    /**
     * Initialize selected variant model values with the first available
     * variant.
     */
    initSelectedVariantModelValues() {
      this.attachments.forEach((attachment) => {
        if (this.hasMultiVariants(attachment)) {
          this.selectedVariantModelValues[attachment.handle] = attachment.variants[0].id
        }
      })
    },

    /**
     * Toggle active accordion.
     * @param {Number} targetIndex -  Index of an accordion.
     */
    toggleAccordion(targetIndex) {
      if (this.isActive(targetIndex)) {
        this.activeAccordion = false
        return
      }

      this.activeAccordion = targetIndex
    },


    /**
     * Check if an accordion is active.
     * @param {Number} index - Index of an accordion.
     */
    isActive(index) {
      return this.activeAccordion === index
    },

    /**
     * Check if attachment is part of the selected attachments
     */
    isSelectedAttachment(attachment) {
      let isSelected = false

      if (this.selectedAttachments.length === 0) {
        return false
      }

      this.selectedAttachments.forEach((selected) => {
        if (attachment.hasOnlyDefaultVariant &&
          selected.id === attachment.selectedOrFirstAvailableVariant.id
        ) {
          isSelected = true
          return isSelected
        }

        const match = attachment.variants.findIndex(product => product.id === selected.id)
        if (match >= 0) {
          isSelected = true
          return isSelected
        }

        return false
      })

      return isSelected
    },

    /**
     * Handle attachment variant selection.
     * - updates the selected attachments array with the variant model values if
     * the attachment is already selected.
     */
    handleVariantSelection() {
      if (this.selectedAttachments.length === 0) {
        return
      }

      for (const [handle, variantId] of Object.entries(this.selectedVariantModelValues)) {
        const target = this.selectedAttachments.findIndex((attachment) => {
          return attachment.handle === handle
        })

        if (target > -1 &&
          this.selectedAttachments[target].id !== variantId) {

          this.selectedAttachments.splice(target, 1)
          this.$emit('update-selected-attachments', this.selectedAttachments)

          const attachment = this.attachments.find((item) => {
            return item.handle === handle
          })
          const variant = attachment.variants.find((item) => {
            return item.id === variantId
          })

          this.pushSelectedAttachment(attachment, variant)
        }
      }
    },

    /**
     * Handle attachment selection.
     * @param {Object} attachment - Attachment object.
     */
    handleAttachmentSelection(attachment) {
      if (this.isSelectedAttachment(attachment)) {
        this.removeSelectedAttachment(attachment)
        return
      }

      let variant = attachment.variants ? attachment.variants[0] : attachment

      if (this.hasMultiVariants(attachment)) {
        const variantIds = Object.values(this.selectedVariantModelValues)

        variant = attachment.variants.find((item) => {
          return variantIds.includes(item.id)
        })
      }

      if (variant) {
        this.pushSelectedAttachment(attachment, variant)
      }
    },

    /**
     * Push attachment to the selected attachments array.
     * @param {Object} attachment - Attachment object.
     * @param {Object} variant - Variant object.
     */
    pushSelectedAttachment(attachment, variant) {
      const data = {
        id: variant.id,
        quantity: 1,
        title: attachment.title,
        handle: attachment.handle,
        price: variant.price,
        variant: variant.title,
        compatibility: attachment.compatibility,
        leadTime: variant.leadTime,
      }

      this.selectedAttachments.push(data)
      this.$emit('update-selected-attachments', this.selectedAttachments)
    },

    /**
     * Remove attachment from the selected attachments array.
     * @param {Object} attachment - Attachment object.
     */
    removeSelectedAttachment(attachment) {
      const target = this.selectedAttachments.findIndex((product) => {
        return product.handle === attachment.handle
      })

      this.selectedAttachments.splice(target, 1)
      this.$emit('update-selected-attachments', this.selectedAttachments)
    },
  },
}
</script>
